(function (global) {

    function createInput(name, value) {
        var input = document.createElement('input');
        input.type = 'hidden';
        input.name = name;
        input.value = value;
        return input;
    }

    global.h5redirect = function (options) {
        var doc = global.document,
            protocol = global.location.protocol;
        // 授权后跳转的URL
        var url = options.url || 'http://h5.upliveapp.com/uppro/index.html';
        // 存储信息的,key,value的形式
        var storeData = options.data || {};
        // 中转页的地址，域名和授权后的url一致就可以了
        var origin = url.match(/https?:\/\/(.*?)\//)[1] || 'h5.upliveapp.com';
        var redirectAction = protocol + '//' + origin + '/h5redirect/redirect.php';

        if (origin.indexOf('aws') > -1) {
            redirectAction = protocol + '//' + origin + '/up/h5redirect/redirect.php';
        }

        var form = doc.createElement('form');
        form.action = redirectAction;
        form.method = 'post';
        form.target = '_blank';
        form.style.display = 'none';
        form.appendChild(createInput('url', url));
        form.appendChild(createInput('data', JSON.stringify(storeData)));

        document.body.appendChild(form);
        form.submit();
        document.body.removeChild(form);
    };
})(window);



//////////////////
// WEBPACK FOOTER
// ./js/redirect.js
// module id = 1
// module chunks = 0